(() => {
  function initialise(section) {
    if (section.dataset.scribliReady) return;
    section.dataset.scribliReady = 'true';
    const main = section.querySelector('[data-gallery-main]');
    const mainLink = section.querySelector('[data-gallery-open]');
    const dialog = section.querySelector('[data-scribli-dialog]');
    const dialogImage = section.querySelector('[data-dialog-image]');
    const dialogCaption = section.querySelector('[data-dialog-caption]');
    let lastTrigger;
    function openPreview(event, link, src, caption) {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      lastTrigger = link;
      dialogImage.src = src;
      dialogImage.alt = caption;
      dialogCaption.textContent = caption;
      dialog.showModal();
      document.documentElement.classList.add('scr-preview-open');
    }
    section.querySelectorAll('[data-gallery-thumb]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        main.src = link.href;
        main.alt = link.dataset.caption;
        mainLink.href = link.href;
        section.querySelectorAll('[data-gallery-thumb]').forEach(item => {
          item.classList.toggle('is-selected', item === link);
          if (item === link) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      });
    });
    mainLink?.addEventListener('click', event => openPreview(event, mainLink, main.src, main.alt));
    section.querySelectorAll('[data-preview-open]').forEach(link => {
      link.addEventListener('click', event => openPreview(event, link, link.href, link.querySelector('img').alt));
    });
    section.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog?.addEventListener('close', () => {
      document.documentElement.classList.remove('scr-preview-open');
      lastTrigger?.focus();
    });
    section.querySelectorAll('[data-review-carousel]').forEach(carousel => {
      const track = carousel.querySelector('[data-review-track]');
      const cards = [...track.querySelectorAll('.scr-proof__card')];
      const dots = [...carousel.querySelectorAll('[data-review-index]')];
      const update = () => {
        const step = (cards[0]?.getBoundingClientRect().width || 1) + 16;
        const index = Math.round(track.scrollLeft / step);
        dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        const step = cards[0].getBoundingClientRect().width + 16;
        track.scrollTo({left: index * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) {
        const resize = new ResizeObserver(update);
        resize.observe(track);
        section.addEventListener('shopify:section:unload', () => resize.disconnect(), {once: true});
      }
    });
    const sticky = section.querySelector('[data-scribli-sticky]');
    const offer = section.querySelector('.scr-offer');
    if (sticky && offer && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0 || !!document.querySelector('[role="alertdialog"]');
      }, { threshold: 0 });
      observer.observe(offer);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    }
    const form = section.querySelector('.scr-product-form');
    form?.addEventListener('submit', () => {
      // Keep Shopify's native form submission so checkout and analytics work without JavaScript.
      section.querySelectorAll(`[form="${form.id}"], [data-main-submit]`).forEach(button => {
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding to cart…';
      });
    });
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        section.querySelectorAll('[aria-busy="true"]').forEach(button => {
          button.removeAttribute('aria-busy');
          button.textContent = 'Get the bundle →';
        });
      }
    });
  }
  document.querySelectorAll('[data-scribli-section]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-scribli-section]').forEach(initialise);
  });
})();
